import { WorkspaceDocList } from "@/features/docs/WorkspaceDocList";
import { SchedulePeekDrawer } from "@/features/docs/SchedulePeekDrawer";
import { RecordDrawer } from "@/features/records/RecordDrawer";
import { ExecutionTaskDrawer } from "@/features/tasks/ExecutionTaskDrawer";

/** 워크스페이스에서 읽을 수 있는 문서. 행을 열면 그 플랜의 편집기로 간다. */
export function WorkspaceDocsPage() {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
      <WorkspaceDocList />
      <ExecutionTaskDrawer />
      <RecordDrawer />
      <SchedulePeekDrawer />
    </div>
  );
}
